<template lang="html">
    <div class="">
        <div class="row">

            <div class="col-sm-4">

                <div class="d-flex w-100 justify-content-between">
                    <label class="full" v-if="!pricePerOrder">Price Category</label>
                </div>

                <v-select
                    v-if="audienceTypes && !isCustomGenderPrice(pricePerPerson)"
                    v-model="pricePerPerson.audienceTypeHelper"
                    :options="audienceTypes"
                    label="description"
                    placeholder="- Select type -"
                    :disabled="disabled"
                    @input="updateAudienceType(pricePerPerson, pricePerPerson.audienceTypeHelper)">
                </v-select>

                <input v-if="isCustomGenderPrice(pricePerPerson)" :disabled="disabled" class="w-100" type="text" style="width: 3rem;" v-model="pricePerPerson.audienceTypeDescription">

            </div>

            <div v-if="showDelete && pricePerOrder" class="col-sm-8 d-flex justify-content-end align-items-center">
                <i class="ico-delete fs-large medium" :class="{'pointer':!disabled, 'notAllowed':disabled}" v-tooltip="'Remove'" @click="removePrincingAgeRow(pricePerPerson)"></i>
            </div>

            <div class="col-sm-4" v-if="!pricePerOrder">
                <div class="row">
                    <label class="full">Label</label>
                    <input :disabled="disabled" class="w-100" type="text" style="width: 3rem;" v-model="pricePerPerson.audienceTypeLabel" placeholder="e.g: (> 2 years)">
                </div>
            </div>

            <div class="col-sm-2 pr-0" v-if="!pricePerOrder">
                <label class="full">Occupancy</label>
                <input :disabled="disabled || !isCustomGenderPrice(pricePerPerson)" class="text-center" type="number" style="width: 70px;" v-model="pricePerPerson.audienceTypeOccupancy" placeholder="1">
            </div>
        </div>

        <div class="row align-items-center mt-2" v-if="!pricePerOrder">
            <div class="col-sm-3">
                <label class="full">Tax</label>
                <input type="text" disabled="disabled" :value="customPerPersonTaxes(pricePerPerson.productGenderPriceComponents)" class="w-100" v-if="pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length > 0"></input>
                <v-select
                    v-if="taxes && pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length <= 0"
                    v-model="pricePerPerson.vatTypeHelper"
                    :options="taxes"
                    label="description"
                    placeholder="- Select tax -"
                    :disabled="disabled"
                    @input="updateTaxType(pricePerPerson, pricePerPerson.vatTypeHelper)">
                </v-select>
            </div>

            <div class="d-flex flex-column">
                <label class="full">Price</label>
                <div>
                    <input type="text" disabled="disabled" :value="customPerPersonTotal(pricePerPerson.productGenderPriceComponents)+' €'" class="w-100" v-if="pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length > 0"></input>
                    <div class="d-flex" v-else>
                        <input class="glued-right" type="number" style="width: 4rem;" :disabled="disabled" v-model="pricePerPerson.value">
                        <div class="glued-left">€</div>
                    </div>
                </div>
            </div>

            <div class="d-flex mr-3 flex-grow-1 flex-column">
                <!-- spacing -->
                <label class="full">&nbsp;</label>
                <div class="d-flex mt-2 ml-2">
                    <div class="d-flex flex-grow-1">
                        <i class="fas fa-calculator fs-large medium" :class="{'pointer':!disabled, 'notAllowed':disabled}" v-tooltip="'Edit'" @click="openEditPrice(pricePerPerson)"></i>
                    </div>
                    <div class="text-right">
                        <i class="ico-delete fs-large medium" :class="{'pointer':!disabled, 'notAllowed':disabled}" v-tooltip="'Remove'" v-if="showDelete" @click="removePrincingAgeRow(pricePerPerson)"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import extendedVSelect from '@/extends/vue-select'

export default {
    props: {
        pricePerPerson: {
            type: Object,
            required: true
        },
        showDelete: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        pricePerOrder: {
            type: Boolean,
            default: false
        },
        audienceTypes: {
            type: Array,
        }
    },
    computed: {
        ...mapGetters([
            'getAudienceTypeList',
            'getVatTypes',
            'getModal',
        ]),
        taxes: function () {
            return this.getVatTypes
        }
    },
    methods:{
        ...mapActions([
            'openModal',
            'updateroductEditPriceData'
        ]),
        isCustomGenderPrice: function(pricePerPerson) {
            return pricePerPerson.audienceType >= 500
        },
        updateAudienceType: function(row, selectedAudienceType){
            row.audienceType = selectedAudienceType.id;
            row.audienceTypeDescription = selectedAudienceType.description;
        },
        customPerPersonTaxes: function(row) {
            let taxes = [];
            for (let service of row) {
                // if(taxes.indexOf(service.component.vatType+'%') == -1){
                //     taxes.push(service.component.vatType+'%')
                // }
                if(service.component.selectedPrice && taxes.indexOf(service.component.selectedPrice.vatType+'%') == -1){
                    taxes.push(service.component.selectedPrice.vatType+'%')
                }
            }
            return taxes.join(', ')
        },
        updateTaxType: function(row, selectedVatType){
            if(!selectedVatType){
                selectedVatType = this.taxes[0]
            }
            row.vatType = selectedVatType.id;
        },
        customPerPersonTotal: function(row) {
            let total = 0;
            for (let service of row) {
                // total += service.component.priceTotal
                if(service.component.selectedPrice){
                    total += service.component.selectedPrice.grossprice
                }
            }
            return (total).toFixed(2).replace(".", ",");
        },
        openEditPrice: function(priceRow) {
            if(this.disabled){
                return false
            }

            // priceRow.id = null // is this really needed? -> removed to allow edit product

            this.updateroductEditPriceData(priceRow)

            // if we open the "Edit Price" modal and we are already on a modal, then we need to seed a callback to re-open the previous modal
            if(this.getModal.show === false){
                this.openModal('ProductEditPrice');
            } else {
                let currentModal = this.getModal.template
                this.openModal({
                    name: 'ProductEditPrice',
                    callback: () => {
                        console.log('EDIT PRICE CALLBACK', currentModal);
                        this.openModal(currentModal)
                    }
                });
            }
        },
        removePrincingAgeRow: function (index) {
            if(this.disabled){
                return false
            }
            this.$emit('delete', index)
        },
    },
    components: {
        vSelect: extendedVSelect,
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// priceRow.vue?f7754d98